import { useMutation } from 'react-query';
import { network } from 'services/network';

const shareInsight = (params) => {
    return network
        .post('api/bo/notification/insightEmailNotification', params)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useMutationShareInsight = () => {
    return useMutation<any, QueryError, any>((params) => shareInsight(params));
};
